import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const EspecialidadesContainer = styled.section`
    width: 65%;
    margin: 2.5% auto;

    header{
        h1{
            font-size: 2rem;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        margin: 10% auto;
        width: 80%;

        header{
            h1{
                font-size: 1.5rem;
            }
        }
    }
`;

export const EspecialidadeWrapper = styled.article`
    width: 100%;
    margin-top: 2.5%;
    display: flex;
    flex-wrap: wrap;
`;

export const EspecialidadeItem = styled.aside`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2%;
    border-radius: 20px;
    margin-top: 2.5%;

    background-color: ${Colors.lighBrown};

    &:not(:nth-child(4n)),
    &:not(:first-child){
        margin: 2.5% 2.5% 0 2.5%;
    }

    img{
        width: 40px;
        height: 40px;
        padding: 5px;
        margin-right: 10px;
    }

    h2{
        font: .95rem / 1.2 "Varela Round",arial,sans-serif;
        color: ${Colors.grey};
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        padding: 5%;

        &:not(:nth-child(4n)),
        &:not(:first-child){
            margin: 2.5% 0 0 0;
        }

        img{
            width: 20px;
            height: 30px;
            padding: 0;
        }

        h2{
            font-size: .85rem;
        }

    }
`;
